import $pageBack from '~/utils/page-back'

export default function (context, inject) {
  // $pageBack.init()
  inject('pageBack', $pageBack)
}
